﻿<template>
    <fragment>
        <div class="builder-bottom-right">
            <router-link :to="nextTabLink" v-slot="{ navigate }">
                <Button @click.native="navigate">{{resource('Button_Next')}}</Button>
            </router-link>
        </div>

        <slot v-bind:tabId="currentTabId" />

        <div class="builder-bottom-right">
            <router-link :to="nextTabLink" v-slot="{ navigate }">
                <Button @click.native="navigate">{{resource('Button_Next')}}</Button>
            </router-link>
        </div>
    </fragment>
</template>

<script>
    import {RouteNames} from "@modules/AudienceManager/constants";

    import {createNamespacedHelpers} from 'vuex';
    import resourceMixin from "@core/Util/Mixins/resources";
    import {currentTabIdMixin} from "./Mixins";
    import QuestionTab from './QuestionTab';
    
    const {mapGetters} = createNamespacedHelpers('audienceManager/builder');
    
    export default {
        name: "NavigateableQuestionTab",
        components: {
            QuestionTab
        },
        mixins: [resourceMixin, currentTabIdMixin],
        computed: {
            ...mapGetters(['nextTabId']),
            nextTabLink() {
                //This will brick once we place a second tab before our first question tab
                const nextTabId = this.nextTabId(this.currentTabId);
                
                //No next tab implies our next tab is our overview tab
                if(!nextTabId){
                    return { name: RouteNames.BUILDER_OVERVIEW_TAB };
                }
                
                return {
                    name: RouteNames.BUILDER_QUESTION_TAB,
                    params: {
                        tabId: nextTabId
                    }
                }
            }
        }
    }
</script>
